export default {
  token: "",
  userGeo: {
    type: Object,
    default: () => ({}),
  },
  isLoggedIn: false,
};
